/* eslint-disable react-hooks/exhaustive-deps */
import classNames from 'classnames/bind';
import styles from './CvPage.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faCheck, faDownload, faEllipsisVertical } from '@fortawesome/free-solid-svg-icons';
import { useEffect, useRef, useState } from 'react';
import Line from './components/Line';
import ProjectList from '~/component/ProjectItem/ProjectList';
import NavBar from '~/component/NavBar';
import { BASE_URL_IMG, downloadFile, getData } from '~/helper/apiService';
import { FaEnvelope, FaFacebook, FaGithub, FaLinkedin } from 'react-icons/fa';
import VideoCard from '~/component/VideoCard';
import images from '~/assets';
import { scrollToTop2 } from '~/helper/scroll';
import useMeta from '~/hooks/useMeta';
import routes from '~/configs';

const cx = classNames.bind(styles);

function CvPage() {
  const [isShowBar, setIsShowBar] = useState(true);
  const [information, setInformation] = useState([]);
  const [skills, setSkills] = useState([]);
  const [educations, setEducations] = useState([]);
  const [projects, setProjects] = useState([]);

  useMeta({
    title: "NGO GIA QUYEN - Fullstack Developer | ReactJS Enthusiast",
    description: "CV của Ngô Gia Quyến, một Fullstack Developer với đam mê ReactJS và công nghệ. Khám phá các kỹ năng chuyên môn và dự án của tôi.",
    keywords: "Ngô Gia Quyến, Fullstack Developer, ReactJS, CV, lập trình, Python, Django, MySQL, MongoDB, GitHub, SASS",
    author: "Ngô Gia Quyến",
    url: routes.cV,
  });


  const pageRef = useRef();
  useEffect(() => {
    scrollToTop2(pageRef);
  }, []);

  const handleShowBar = () => {
    setIsShowBar((prev) => {
      if (!prev) setIsExpandMenu(false);
      return !prev;
    });
  };

  const [isExpandMenu, setIsExpandMenu] = useState(null);

  const handleExpandMenu = () => {
    setIsExpandMenu((prev) => {
      if (!prev) return true;
      return false;
    });
  };

  const [cvInfo, setCvInfo] = useState({});

  const parseSkills = (value) => {
    const lines = value
      .split('\n')
      .map((line) => line.replaceAll('\r', '')) // Xóa ký tự \r trước
      .filter((line) => line !== ''); // Lọc bỏ dòng rỗng

    return lines;
  };

  const loadData = async () => {
    const res = await getData('/cv/read');
    setCvInfo(res[0]);
    setInformation(parseStringToTable(res[0].information));
    setSkills(parseSkills(res[0].skills));
    setEducations(parseSkills(res[0].education));
  };
  const loadProjects = async () => {
    const res = await getData('/projects/read');
    setProjects(res);
  };

  const parseStringToTable = (inputString) => {
    const lines = inputString.split('\\n'); // Tách từng dòng
    const newTableData = [];

    lines.forEach((line, index) => {
      const [key, value] = line.split('/:').map((item) => item.trim()); // Tách key và value
      if (key && value) {
        newTableData.push({ key, value }); // Lưu vào tableData
      }
    });
    return newTableData; // Cập nhật state
  };

  useEffect(() => {
    loadData();
    loadProjects();
  }, []);

  const handleDownloadCv = () => {
    downloadFile('/cv/download', 'software_ngogiaquyen.pdf');
  };

  return (
    <div ref={pageRef} className={cx('wrapper')}>
      {/* bar */}
      <div className={cx('top-bar')}></div>
      <div className={cx('info-bar', { show: isShowBar, hide: !isShowBar })}>
        <div className={cx('info-bar-frame')}>
          <divc className={cx('info-bar-header')}>
            <FontAwesomeIcon className={cx('icon')} icon={faEllipsisVertical} onClick={handleShowBar} />
          </divc>
          <div className={cx('info-head')}>
            <div className={cx('info-head-img')}>
              <img alt="" className={cx('info-img')} src={BASE_URL_IMG + '/' + cvInfo.avatar} />
            </div>
            <h5 className={cx('info-name')}>{cvInfo.name}</h5>
            <p className={cx('info-text')}>{cvInfo.job_position}</p>
          </div>

          <Line />
          <div className={cx('info-table')}>
            <ul className={cx('table-list')}>
              {information.map((info, index) => (
                <li className={cx('table-item')} key={index}>
                  <h6>{info.key}</h6>
                  <span>{info.value}</span>
                </li>
              ))}
            </ul>
          </div>

          <Line />

          <div className={cx('knowledge')}>
            {skills.map((line, index) => {
              if (line.startsWith('#')) {
                return <h5 className={cx('knowledge-title')}>{line.replaceAll('#', '')}</h5>;
              }
              return (
                <div className={cx('knowledge-item')}>
                  <FontAwesomeIcon className={cx('icon')} icon={faCheck} />
                  <span>{line}</span>
                </div>
              );
            })}
            <div className={cx('knowledge-item')}>
              <FontAwesomeIcon className={cx('icon')} icon={faCheck} />
              <span>SASS</span>
            </div>
          </div>

          <Line />

          <div className={cx('download-cv')} onClick={handleDownloadCv}>
            <span>TẢI XUỐNG CV</span>
            <FontAwesomeIcon icon={faDownload} />
          </div>

          <div className={cx('social')}>
            {/* <FontAwesomeIcon icon={faFacebook} />
            <FontAwesomeIcon icon={faFacebook} />
            <FontAwesomeIcon icon={faFacebook} />
            <FontAwesomeIcon icon={faFacebook} /> */}
            <a href="https://github.com/ngogiaquyen" target="_blank" rel="noreferrer">
              <FaGithub />
            </a>
            <a href="https://www.linkedin.com/in/quyen-ngo-gia" target="_blank" rel="noreferrer">
              <FaLinkedin />
            </a>
            <a href="mailto:ngogiaquyendhtn223@gmail.com" target="_blank" rel="noreferrer">
              <FaEnvelope />
            </a>
            <a href="https://www.facebook.com/share/165jkkeQ9a/?mibextid=wwXIfr" target="_blank" rel="noreferrer">
              <FaFacebook />
            </a>
          </div>
        </div>
      </div>

      <div className={cx('overlay', { show: isShowBar })} onClick={handleShowBar}></div>

      {/* container */}
      <div className={cx('container')}>
        <div className={cx('banner')}>
          <div className={cx('overlay-banner')}></div>
          <div className={cx('video')}>
            <VideoCard src={images.bannerVideo} loop />
          </div>
          {/* <h5>Discover my Amazing Art Space!</h5> */}
          <span>{cvInfo.target}</span>
        </div>
        <Line />
        {educations.length === 4 && (
          <div className={cx('educations')}>
            <div className={cx('educations-row')}>
              <h2>{educations[0]}</h2>
              <p>{educations[1]}</p>
            </div>
            <p>
              <span className={cx('highlight')}>Chuyên ngành: </span>
              {educations[2]}
            </p>
            <p>
              <span className={cx('highlight')}>GPA: </span>
              {educations[3]}
            </p>
          </div>
        )}
        <Line />

        <div className={cx('projects')}>
          <h2>My projects</h2>
          <ProjectList data={projects} />
        </div>
      </div>

      {/* menu */}
      <div className={cx('menu', { expand: isExpandMenu, marrow: !isExpandMenu && isExpandMenu !== null })}>
        <div className={cx('menu-bars')} onClick={handleExpandMenu}>
          <FontAwesomeIcon className={cx('bar-icon')} icon={faBars} />
        </div>
        <div className={cx('navbar', { show: isExpandMenu })}>{<NavBar col transparent fixed={false} />}</div>
      </div>
    </div>
  );
}

export default CvPage;
